import React, { ReactNode } from 'react';
import { DmdcuDataContext } from '../api/dmdcuDataContext';
import BrowserUI from './browserUI';
import AssetEditorUI from './assetEditorUI';
import { UniqMotorcycle, Certifier } from '../api/dmdcuData';
import AssetDetailsUI from './assetDetailsUI';
import LoadingUI from './loadingUI';
import CertifiersUI from './certifiersUI';
export interface IBodyUIProps {
  dataContext: DmdcuDataContext;
}

enum BrowserUILoadingState {
  Unintialized,
  Loading, // it's about to load data from the blockchain
  Loaded, // the data is loaded, but not processed in the UI yet.
  Ready, // the data is processed in the UI as well, everything is ready.
  LoadFailed, // loading failed because of an error.
}

export class BodyUIState {

  public loadingState: BrowserUILoadingState = BrowserUILoadingState.Unintialized;
  public loadedUniqueMotorcycle?: UniqMotorcycle = undefined;

}

export class DmdcuBody extends React.Component<IBodyUIProps, BodyUIState> {

  private hashChangeIsRegistered: boolean = false;
  private loadingState: BrowserUILoadingState = BrowserUILoadingState.Unintialized;
  private loadedUniqueMotorcycle?: UniqMotorcycle = undefined;
  private loadingError?: string;

  public setLoadingState(state: BrowserUILoadingState) {
    this.loadingState = state;
  }

  private setUniqueMotorcycle(moto: UniqMotorcycle) {

    this.loadedUniqueMotorcycle = moto;
    this.loadingState = BrowserUILoadingState.Loaded;
    this.forceUpdate();
  }

  private setLoadingError(error: string) {

    this.loadingState = BrowserUILoadingState.LoadFailed;
    this.loadingError = error;
    this.forceUpdate();
  }

  public render(): ReactNode {

    console.log('DmdcuBody Render called!');

    if (this.loadingState === BrowserUILoadingState.Loading) {
      return <LoadingUI />;
    }

    if (this.loadingState === BrowserUILoadingState.Loaded) {
      this.loadingState = BrowserUILoadingState.Ready;
      if (!this.loadedUniqueMotorcycle) {
        throw Error('Internal logical Error: Asset should be loaded but is not.');
      }
      return <AssetDetailsUI dataContext={this.props.dataContext} motorcycle={this.loadedUniqueMotorcycle} />;
    }

    if (this.loadingState === BrowserUILoadingState.LoadFailed) {
      this.loadingState = BrowserUILoadingState.Ready;
      const displayedError = this.loadingError;
      this.loadingError = undefined;
      return <div>Loading Failed: `${displayedError}`</div>;
    }

    let bodyUI;
    if (window.location.hash === '#new-asset') {

      // todo: Load current certifier!! but doesn't realy matter, since the newly created moto is sent to blockchain and retrieved back.
      const certifier = new Certifier('unknown', 'AT-123', '0x123', 'www.blockserv.at', '', '');
      const moto = new UniqMotorcycle(0, '0', '', '', '', '', certifier, 1, new Date(2000, 1), new Date(Date.now()), 0, 0, 0, 0, 0, 0);

      bodyUI = <AssetEditorUI dataContext={this.props.dataContext} motorcycle={moto} />;
    } else if (window.location.hash === '#browser') {
      bodyUI = <BrowserUI dataContext={this.props.dataContext} />;
    } else if (window.location.hash === '#certifiers') {
      bodyUI = <CertifiersUI />;
    } else {

      let motoID: number = Number.NaN;
      if (window.location.hash.length > 1) {
        const numberPart = window.location.hash.substr(1);
        motoID = parseInt(numberPart, 16);
        // console.log('assetID: ' + this.props.dataContext.api.web3.utils.hexToNumber(numberPart));
      }

      if (!isNaN(motoID)) {
        console.log('set state to loading');
        this.setLoadingState(BrowserUILoadingState.Loading);
        console.log('query motorcycle');
        this.props.dataContext.getUniqueMotorcycle(motoID).then(
          (success) => {
            console.log('setting moto!', success);
            this.setUniqueMotorcycle(success);
          },
          (failure) => {
            console.error('Unable to Load', failure);
            // this.setLoadingState(BrowserUILoadingState.LoadFailed);
            this.setLoadingError(`Unable to load uNiq ID: ${window.location.hash}`);
          });
        console.log('asigning LoadingUI');
        bodyUI = <LoadingUI />;
      }

      bodyUI = <BrowserUI dataContext={this.props.dataContext} />;
    }
    return bodyUI;
  }

  componentDidMount() {
    if (!this.hashChangeIsRegistered) {
      window.addEventListener('hashchange', () => {
        console.log('The hash has changed!', window.location.hash);
        this.forceUpdate();
      });
      this.hashChangeIsRegistered = true;
    }
  }
}

export default DmdcuBody;
